import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const AsignacionCuentasSegmentacionOportunidades = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/02-asignación-de-cuentas-y-segmentación-de-oportunidades.pdf`;
  /*const pdfUrl = "/pdf/02-asignación-de-cuentas-y-segmentación-de-oportunidades.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Asignación de Cuentas y Segmentación de Oportunidades</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Asignación de Cuentas y Segmentación de Oportunidades" />
      </Container>
    </>
  );
};

 export default AsignacionCuentasSegmentacionOportunidades;
